// breeze-purchase event listener
window.addEventListener("message", (event) => {
  try {
    const eventData = JSON.parse(event.data);
    if (eventData.source === "breeze" && eventData.payload) {
      const payload = JSON.parse(eventData.payload);
      breezePurchase(payload);
    } else {
      console.log("Invalid event source or missing payload");
    }
  } catch (e) {
    console.log("Error parsing event data: ", e);
  }
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload);
  } catch (e) {
    console.log("Error in triggering merchants purchase script: ", e);
  }
}

// Merchant script for purchase will be pasted here
function merchantPurchaseCustomCode(params) {
  if (params.paymentMethodType && params.paymentMethodType.toUpperCase() !== "CASH") {
    console.log(">>> Event  sent: payment method is CASH or not provided",params);
    fbq('trackCustom', 'PrePaidPurchase', {
      order_id: params.shopOrderId,
      value: params.totalPrice,
      currency: params.currency,
      shipping: params.shippingCharge,
      paymentMethodType: params.paymentMethodType,
      items: convertToMerchantParams(params.items),
    });

  } else {
    console.log(">>> Event not sent: payment method is CASH or not provided");
  }

  console.log("End of merchantPurchaseCustomeCode");
}

// Helper function to convert items to the required format
function convertToMerchantParams(items) {
  return items.map((item) => {
    return {
      id: item.id,
      name: item.name,
      price: item.price,
      quantity: item.quantity,
      variant: item.variant,
    };
  });
}
